import { FC, ReactNode, useState } from 'react'
import { Tooltip } from './primitives'

export function withTooltip<P extends object>(
  baseComponent: FC<P>,
  side?: 'bottom' | 'left' | 'right' | 'top',
  maxWidth?: string
): FC<P & { tooltipText?: ReactNode; isDisabled?: boolean }> {
  const Component = baseComponent
  return (props: P & { tooltipText?: string; isDisabled?: boolean }) => {
    const [isOpen, setIsOpen] = useState(false)

    const { tooltipText, isDisabled, ...otherProps } = props

    const handleOpen = () => setIsOpen(true)
    const handleClose = () => setIsOpen(false)

    if (isDisabled) {
      return <Component {...(otherProps as P)} />
    }

    return (
      <Tooltip.Root delayDuration={300} open={isOpen}>
        <Tooltip.Trigger
          asChild
          onMouseOver={handleOpen}
          onMouseLeave={handleClose}
          onClick={handleOpen}
        >
          <Component {...(otherProps as P)} />
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content sideOffset={5} side={side} css={{ maxWidth }}>
            {tooltipText}
            <Tooltip.Arrow />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    )
  }
}
